import { picoapp } from 'picoapp'

import slaterWelcome from '@/components/slater-welcome.js'

import header from '@/components/header.js'
import productSelection from '@/components/product-selection.js'
import cartDrawer from '@/components/cartDrawer.js'
import cartDrawerItem from '@/components/cartDrawerItem.js'
import accountLogin from '@/components/accountLogin.js'
import product from '@/components/product.js'
import productCounter from '@/components/product-counter.js'
import collection from '@/components/collection.js'
import passwordInputState from '@/components/password-input-state.js'
import customerDrawerCfLabelClass from '@/components/customer-drawer-cf-label-class.js'
import countdown from '@/components/countdown.min.js'

const state = {
  cartOpen: false
}

const components = {
  slaterWelcome,
  accountLogin,
  header,
  productSelection,
  cartDrawer,
  cartDrawerItem,
  product,
  productCounter,
  collection,
  passwordInputState,
  customerDrawerCfLabelClass,
  countdown
}


export default picoapp(components, state)
